/**
 * @name 图标
 */
import base from '../../base';
import AbEntryMenu from './EntryMenu';

AbEntryMenu.install = function(Vue) {
  Vue.use(base);
  Vue.component(AbEntryMenu.name, AbEntryMenu);
};

export default AbEntryMenu;
